import { present } from 'shared/presenters/presenter'
import { Invited_Children } from 'shared/presenters/graphqlTypes'

export class InvitedChildPresenter extends present<Invited_Children>() {}
